type TDebugLogKeys = 'contractSocketData'
function debugLog(key: TDebugLogKeys, ...args) {
  if (typeof window === 'undefined') return
  const storageKeys = window.localStorage.getItem('debugLogKeys')
  if (!storageKeys) return
  const keys = storageKeys.split(',')
  if (!keys.includes(key)) return
  console.log(key, ...args)
}

export default debugLog
